import React, { Fragment } from 'react';
import { Button, Table, Popup, Icon, Header, Form } from 'semantic-ui-react';
import axios from 'axios';
import { Link } from 'react-router-dom';
import { ToastContainer, toast } from 'react-toastify';
import SearchTableData from '../../util/SearchTableData';

axios.defaults.xsrfHeaderName = 'X-XSRF-TOKEN';
axios.defaults.xsrfCookieName = 'XSRF-TOKEN';
axios.defaults.withCredentials = true;

const NoDataMessage = () => <p><br />Nema studijskih programa.</p>;


export default class StudyPrograms extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            active: true,
            results: [],
            studyCycleId: null,
            archived: localStorage.getItem('archived'),
        };
        this.getResults = this.getResults.bind(this);
        this.getDataToRender = this.getDataToRender.bind(this);
        this.handleInputChange = this.handleInputChange.bind(this);
    }

    UNSAFE_componentWillReceiveProps(nextProps) {
        if (this.state.archived !== nextProps.archived) {
            this.setState({
                results: []
            });
            this.props.loading;
        }
    }

    getDataToRender() {
        if (this.state.results.length !== 0) {
            if (this.state.studyCycleId) {
                return this.state.results.filter(el => (el.studyProgramBasic.studyCycles[0].id === this.state.studyCycleId));
            }
            return this.state.results;
        } else if (this.state.studyCycleId) {
            return this.props.data.filter(el => (el.studyProgramBasic.studyCycles[0].id === this.state.studyCycleId));
        }
        return this.props.data;
    }

    getResults(results) {
        this.setState({ results });
    }

    handleInputChange(event, { name, value }) {
        this.setState({
            [name]: value
        });
    }

    render() {
        return (
            <div>
                <Fragment>

                    <Table celled selectable compact >
                        <Table.Header>
                            <Table.Row>
                                <Table.HeaderCell colSpan={11} >
                                    <div style={{ paddingLeft: '30px' }}>
                                        <SearchTableData data={this.getDataToRender()} getResults={this.getResults} filterItem={['studyProgramBasicName']} />
                                    </div>
                                </Table.HeaderCell>
                                <Table.HeaderCell colSpan={2} >
                                    <Form.Field >
                                        {/* <label>Studijski ciklus</label> */}
                                        <Form.Dropdown
                                            clearable
                                            selection
                                            placeholder="Odaberite studijski ciklus"
                                            value={this.state.studyCycleId}
                                            onChange={this.handleInputChange}
                                            name="studyCycleId"
                                            options={this.props.studyCycles}
                                            // options={this.props.studyCyclesDropdown}
                                            search
                                            fluid
                                        />
                                    </Form.Field>
                                </Table.HeaderCell>
                            </Table.Row>
                            <Table.Row>
                                <Table.HeaderCell width={1}>
                                    R. br.
                                </Table.HeaderCell>
                                <Table.HeaderCell colSpan={4}>
                                    <Header as="h4">
                                        <Header.Content>
                                            Naziv studijskog programa (B/H/S)
                                        </Header.Content>
                                        <Header.Subheader>Naziv studijskog programa (EN)</Header.Subheader>
                                    </Header>
                                </Table.HeaderCell>
                                {/* <Table.HeaderCell colSpan={4}> */}
                                {/*    Naziv studijskog programa */}
                                {/* </Table.HeaderCell> */}
                                <Table.HeaderCell colSpan={3}>
                                    Ciklus studija
                                </Table.HeaderCell>
                                <Table.HeaderCell colSpan={2}>
                                    Broj odluke
                                </Table.HeaderCell>
                                <Table.HeaderCell colSpan={2}>
                                    Napomena
                                </Table.HeaderCell>
                                <Table.HeaderCell width={1} />
                            </Table.Row>
                        </Table.Header>
                        {this.getDataToRender().length ?
                            <Table.Body> {this.getDataToRender().map((el, index) =>
                                (<Table.Row
                                    style={el.white ? {} : { backgroundColor: '#f2f2f2' }}
                                    key={el.id}
                                >
                                    <Table.Cell verticalAlign="middle" width={1} >
                                        {index + 1}.
                                    </Table.Cell>
                                    <Table.Cell verticalAlign="middle" colSpan={4}>
                                        {el.studyProgramBasic.name} {el.studyProgramBasic.translations && el.studyProgramBasic.translations.map(e => (<div style={{ color: '#a6a4a1' }}>{e.name}<br /></div>))}
                                    </Table.Cell>
                                    <Table.Cell
                                        verticalAlign="middle"
                                        colSpan={3}

                                    >
                                        {el.studyProgramBasic ? el.studyProgramBasic.studyCycles.length ? el.studyProgramBasic.studyCycles[0].name : '' : ''}
                                    </Table.Cell>
                                    <Table.Cell verticalAlign="middle" colSpan={2}>
                                        {el.studyProgramBasic.documentNumber}
                                    </Table.Cell>
                                    <Table.Cell verticalAlign="middle" colSpan={2}>
                                        {el.studyProgramBasic.comment}
                                    </Table.Cell>
                                    <Table.Cell textAlign="center" verticalAlign="middle" width={1}>
                                        <Link to={{ pathname: '/studijski-programi/implementacije', state: { studyCycles: this.state.studyCycles, titles: this.state.titles } }}>
                                            <Popup
                                                content="Implementacije"
                                                position="top center"
                                                trigger={
                                                    <Button
                                                        basic="true"
                                                        circular
                                                        size="small"
                                                        color="blue"
                                                        icon="folder open"
                                                        onClick={() => { localStorage.setItem('studyProgramBasic', el.studyProgramBasic.id); localStorage.setItem('studyProgramBasicName', el.studyProgramBasic.name); }}
                                                    />}
                                            />
                                        </Link>
                                    </Table.Cell>

                                </Table.Row>))}
                            </Table.Body> : <Table.Body> <Table.Row><Table.Cell >
                                <NoDataMessage />
                            </Table.Cell> </Table.Row></Table.Body> }
                    </Table>


                    <ToastContainer hideProgressBar />
                </Fragment>
            </div>

        );
    }
}



// WEBPACK FOOTER //
// ./src/views/StudentService/StudyPrograms/StudyPrograms.js